import { FormGroup } from '@vtbhome/juicyfront';
import { styled } from 'goober';

export const StyledFormGroup = styled(FormGroup)<{ $currentLength: number; $maxLength?: number; $error?: string }>`
    & .rf-form-group__message {
        ${({ $error }) => !$error && 'margin-top: 0 !important;'}
    }

    & .rf-textarea__wrapper,
    textarea {
        min-height: 104px;
        height: unset !important;
    }

    & label::after {
        ${({ $currentLength, $maxLength }) => $maxLength && `content: "${$currentLength}/${$maxLength}" !important;`}
        float: right;
    }
`;
